import styles from './CollapsibleCard.module.scss';
import React, { useState } from 'react';
import clx from 'classnames';
import { ChevronDown } from 'lucide-react';

export default ({
  children,
  title,
  description,
  isOpenDefault = true,
  headerTextClassName,
  titleClassName,
  descriptionClassName,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenDefault);
  return (
    <div className={clx(styles.collapsible_card, { [styles['collapsible_card_close']]: !isOpen })}>
      <div className={styles.card_header} onClick={() => setIsOpen((isOpen) => !isOpen)}>
        <div className={clx(styles.header_text, headerTextClassName)}>
          <div className={clx(styles.title, titleClassName)}>{title}</div>
          {description ? (
            <div className={clx(styles.description, descriptionClassName)}>{description}</div>
          ) : null}
        </div>
        <ChevronDown
          className={clx(styles.chevron, { [styles.chevron_open]: isOpen })}
          size={20}
          strokeWidth={2.25}
          aria-hidden="true"
        />
      </div>
      <div className={styles.card_content}>{children}</div>
    </div>
  );
};
